import { VeiculoModel } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import LocalidadeModel from "@/models/geolocalizacao/LocalidadeModel";
import { QuestionarioModel } from "@/models/cadastros/assistencia/QuestionarioModel";
import { MotivoServicoModel } from "@/models/cadastros/assistencia/chaveiro/MotivoServicoModel";
import ServicoSubClienteModel  from '@/models/cadastros/assistencia/ServicoSubClienteModel';
import { ArquivoAnexoModel } from "@/models/cadastros/assistencia/guincho/ArquivoAnexoModel";
import ClienteAdministrativoModel from "@/models/cadastros/assistencia/ClienteAdministrativoModel";

export class QuestionarioChaveiroModel implements QuestionarioModel {
  idServico?: number;
  veiculoPertenceAoAssociado: boolean;
  veiculo: VeiculoModel;
  localizacao: LocalidadeModel;
  motivoSolicitacao: MotivoServicoModel;
  nomeContatoNoLocal?: string;
  telefoneContatoNoLocal?: string;
  servicoSubCliente?: ServicoSubClienteModel;
  fotosAcidente?: ArquivoAnexoModel[];
  clienteAdministrativo?: ClienteAdministrativoModel;
  constructor(
    veiculoPertenceAoAssociado: boolean,
    veiculo: VeiculoModel,
    localizacao: LocalidadeModel,
    motivoSolicitacao: MotivoServicoModel,
    nomeContatoNoLocal?: string,
    telefoneContatoNoLocal?: string,
    servicoSubCliente?: ServicoSubClienteModel,
    fotosAcidente?: ArquivoAnexoModel[],
    clienteAdministrativo?: ClienteAdministrativoModel,
  ) {
    this.veiculoPertenceAoAssociado = veiculoPertenceAoAssociado;
    this.veiculo = veiculo;
    this.localizacao = localizacao;
    this.motivoSolicitacao = motivoSolicitacao;
    this.nomeContatoNoLocal = nomeContatoNoLocal;
    this.telefoneContatoNoLocal = telefoneContatoNoLocal;
    this.servicoSubCliente = servicoSubCliente;
    this.fotosAcidente = fotosAcidente;
    this.clienteAdministrativo = clienteAdministrativo;
  }
}
